import React from "react";

const OverwritingContent = ({ children }) => {
  return (
    <div
      data-testid="overwriting-content"
      className="absolute top-0 bottom-0 left-0 right-0 overflow-scroll bg-white z-10"
    >
      {children}
    </div>
  );
};

export default OverwritingContent;
